import { useActiveOrganisation } from "@/app/Organisations/Hooks/useActiveOrganisation";
import { useParams } from "@tanstack/react-router";

type TenantType = "admin" | "supplier" | "individual";
export function useTenant() {
  const { activeOrganisation } = useActiveOrganisation();
  const { tenant } = useParams({ strict: false }) as { tenant?: string };

  const isActuallyAdmin = activeOrganisation?.is_admin ?? false;

  let tenantType: TenantType = "individual";

  if (activeOrganisation) {
    // The URL tenant prefix is the source of truth: an admin can drop into the
    // `/org` tree to view as a tenant. Outside a scoped route (no prefix) fall
    // back to the org's real admin flag. Non-admins are always `/org`.
    const isAdmin = tenant ? tenant === "admin" : isActuallyAdmin;
    tenantType = isAdmin ? "admin" : "supplier";
  }

  return {
    tenantType,
    isAdmin: tenantType === "admin",
    isSupplier: tenantType === "supplier",
    isIndividual: tenantType === "individual",
    isActuallyAdmin,
  };
}
